import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ZoomIcon = () => (
  <StaticImage
    className="center"
    style={{ width: "50%" }}
    src={"../images/icons/zoom.png"}
    alt="Zoom icon"
  />
)

export default ZoomIcon
